import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./index.css";
import logo from "../../../../redcliffe_logo.jpeg";
import nabllogo from "./NABL Logo.png";
import mra from "./mra.png";
import DocterSignature from "./prabhakar-signature.png";
import DocterSignature2 from "./nakul-signature.png";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { TableBody, colors } from "@mui/material";
import { Image } from "@progress/kendo-drawing/dist/npm/drawing";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import asset from "./assest8.jpg";
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import Loader from "../../../components/loader/index";
import { PrintDisabled } from "@material-ui/icons";
import NpsRating from "../../NPS";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const NbsReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState<any>("")

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    //Report Data
    const [brcAbl, setbrcAbl] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setbrcAbl(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [bcrReport, setbcrReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setbcrReport(data);
    }, [reportListParameter])


    useEffect(() => {
        setSample_Collected(bcrReport[0]?.collection_date);
        setSample_Receivedtime(bcrReport[0]?.pickup_time);
        setdesignation(bcrReport[0]?.designation);
        setGender(bcrReport[0]?.customer_gender);
        setSample_Received(bcrReport[0]?.pickup_date);
        setAge(bcrReport[0]?.customer_age);
        setName(bcrReport[0]?.customer_name);
        setDob(bcrReport[0]?.dob);
        setUuid(bcrReport[0]?.uuid);
    }, [bcrReport]);

    // useEffect(() => {
    //     if (dob === "") {
    //         getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
    //     }
    //     else {
    //         getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
    //     }
    // }, [dob])

    //Clinical indication
    const [bcrClinData, setbcrClinData] = useState<any>([]);
    useEffect(() => {
        const bcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                bcrclincdata?.push({ ...list });
            });
        }
        setbcrClinData(bcrclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...bcrClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setbcrClinData(storeData);
    }

    //clinical Significance
    const [bcrSignificance, setbcrSignificance] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_significance
            &&
            reportListParameter?.clinical_significance
                .length > 0
        ) {
            reportListParameter?.clinical_significance
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setbcrSignificance(data);
    }, [reportListParameter]);

    const updateSignificance = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrSignificance]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setbcrSignificance(storeData);
    }

    //Methodology
    const [bcrMethology, setbcrMethology] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology &&
            reportListParameter?.methodology.length > 0
        ) {
            reportListParameter?.methodology?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setbcrMethology(data);
    }, [reportListParameter]);

    const updateMethology = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrMethology]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setbcrMethology(storeData);
    }

    //comments
    const [bcrComment, setbcrComment] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_comments &&
            reportListParameter?.clinical_comments.length > 0
        ) {
            reportListParameter?.clinical_comments?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setbcrComment(data);
    }, [reportListParameter]);

    const updateComments = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrComment]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setbcrComment(storeData);
    }
    //Limitations
    const [Limitations, setLimitations] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_limitations
            &&
            reportListParameter?.test_limitations
                .length > 0
        ) {
            reportListParameter?.test_limitations
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setLimitations(data);
    }, [reportListParameter]);

    const updateLimitations = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any
    ) => {
        let storeData = [...Limitations];
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLimitations(storeData);
    };

    //hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //test Details
    const [textDetail, settextDetail] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_details &&
            reportListParameter?.test_details.length > 0
        ) {
            reportListParameter?.test_details?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        settextDetail(data);
    }, [reportListParameter]);

    const updatetextDetail = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...textDetail]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        settextDetail(storeData);
    }

    //Result
    let Data = [
        {
            id: 1,
            name: "BCR Major (P210 e13a2 & e14a2)BCR-ABL rearranged copy number",
            result: " NA"
        },
        {
            id: 2,
            name: "BCR Minor (P190 e1a2) BCR-ABL rearranged copy number",
            result: " NA"
        },
        {
            id: 3,
            name: "BCR Micro (P230 c3a2) BCR-ABL rearranged copy number",
            result: " NA"
        },
        {
            id: 4,
            name: "ABL1 Copy Number",
            result: " NA"
        },
        {
            id: 5,
            name: "Type of Transcript Detected",
            result: "NA"
        },
        {
            id: 6,
            name: "BCR-ABL1 Percentage Ratio (NCN%)",
            result: "NA"
        },
        {
            id: 7,
            name: "BCR-ABL1 International Scale (IS%)",
            result: "NA"
          }
    ];
    const [bcrResult, setbcrResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_result_nipt &&
            reportListParameter?.test_result_nipt.length > 0
        ) {
            reportListParameter?.test_result_nipt?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setbcrResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_result_nipt &&
            reportListParameter?.test_result_nipt.length > 0
        ) {
            data = reportListParameter?.test_result_nipt[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "result":
                newItem.result = value;
                break;

        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    //upload image 
    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);

    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };



    //graph 0
    const [bcrgraph, setGraph] = useState<any>([]);
    useEffect(() => {
        const bcrgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image &&
            reportListParameter?.graph_image?.length > 0
        ) {
            reportListParameter?.graph_image?.map((list: any) => {
                bcrgraph?.push({ ...list });
            });
        }
        setGraph(bcrgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrgraph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph(storeData);
    }


    //upload image 
    const [filePreviews1, setFilePreviews1] = useState<Array<string[]>>([]);

    const handleFileUpload1 = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData1(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews1((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };

    //graph 1
    const [bcrgraph1, setGraph1] = useState<any>([]);
    useEffect(() => {
        const bcrgraph1: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image1 &&
            reportListParameter?.graph_image1?.length > 0
        ) {
            reportListParameter?.graph_image1?.map((list: any) => {
                bcrgraph1?.push({ ...list });
            });
        }
        setGraph1(bcrgraph1);
    }, [reportListParameter]);

    const updateGraphData1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrgraph1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setGraph1(storeData);
    }

    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //doctor list
    const [bcrdoctorList, setbcrdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setbcrdoctorList(data);
    }, [reportListParameter]);


    console.log(bcrdoctorList,"diocnsodicnsdcoi")

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...bcrdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setbcrdoctorList(storeData);
    }
    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }



    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (bcrReport.length > 0) {
            bcrReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrClinData.length > 0) {
            bcrClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }


        if (bcrSignificance.length > 0) {
            bcrSignificance?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrMethology.length > 0) {
            bcrMethology?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrComment.length > 0) {
            bcrComment?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Limitations.length > 0) {
            Limitations?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (textDetail.length > 0) {
            textDetail?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrgraph.length > 0) {
            bcrgraph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrgraph1.length > 0) {
            bcrgraph1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (bcrdoctorList.length > 0) {
            bcrdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (brcAbl.length > 0) {
            brcAbl?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const stringify = JSON.stringify(tableData);
        if (bcrResult.length > 0) {
            bcrResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        // const reportData = {
        //     template_id: secondP,
        //     booking_id: firstP,
        //     case_id: firstP,
        //     status: status,
        //     template_parameter: storeData,
        // };
        // const reportEditData = {
        //     template_id: secondP,
        //     booking_id: firstP,
        //     case_id: firstP,
        //     status: status,
        //     template_parameter: storeData,
        // };
        // if (thirdP === "add") {
        //     await createNewReport(reportData);
        //     navigator('/dashboard/la');
        // } else if (thirdP === "edit") {
        //     await updateReport(reportListParameter?.id, reportEditData);
        // }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };


    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);
        } else {
            setAge(bcrReport[0]?.customer_age);
        }
    }, [dob]);


    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${bcrReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "19%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                                <div style={{ width: "15%", textAlign: "left", padding: 0 }}>
                                    <h3>
                                        <img src={mra} alt="logo" style={{ width: "106px" }} />
                                    </h3>
                                </div>
                                {/* <div  style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                        <h3>
                                           <img src={nabllogo} alt="logo" style={{ width: "75px" }} />
                                        </h3>
                                    </div>
                                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                                        <p style={{ fontSize: "16px", color: "#333", fontWeight: "bold",width:"80px" }}>MC-5280</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-contain-section"> */}
                    <div
                        style={{ width: "100%", textAlign: "center" }}
                        className="bcr_abl1"
                    >
                        <div
                            style={{

                                fontWeight: "bold",
                                fontSize: "25px",
                            }}
                            className="BCR"
                        >
                            <span style={{ fontWeight: "bold", color: "#750b1e" }}>BCR-</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>ABL1 QUANTITATIVE   </span>
                        </div>
                    </div>

                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "18px", marginTop: "13px", }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">

                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {bcrReport[0]?.pk
                                                ? bcrReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : ''}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />

                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {bcrReport[0]?.center?.name && bcrReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid>
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "90%", marginLeft: "42px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Requested:-{bcrReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <br />
                    {/* clinical indication  */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px" }}> CLINICAL INDICATION </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {bcrClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px" }}
                                            rows={3}
                                            cols={132}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>
                    {/* results  */}
                    <div>
                        <h4 style={{ color: "rgb(28, 78, 128)", marginLeft: "45px" }}>
                            Results
                        </h4>
                    </div>
                    <div>
                        <div className="contain" style={{ border: "2px solid rgb(38, 31, 87)", width: "90%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    margin: "10px 0px",
                                                    fontSize: "14px",
                                                    height: "40px",
                                                }}
                                                className={index % 2 === 0 ? 'even-row' : 'odd-row'}
                                            >
                                                <div style={{ width: "48%", marginLeft: 8 }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ marginTop: "7px" }}> :</div>
                                                {list?.risk !== "green" ?
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                        <GrammarlyEditorPlugin>
                                                            <input
                                                                style={{ border: "none", width: "100%", fontWeight: "bold", background: "none", marginTop: "7px" }}
                                                                value={list?.result}
                                                                onChange={(e: any) =>
                                                                    updateRow(index, "result", e.target.value, list)
                                                                }
                                                            />
                                                        </GrammarlyEditorPlugin>
                                                    </div> :
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                    </div>
                                                }
                                            </div>

                                        </>
                                    );
                                })}

                        </div>
                    </div>
                    {/* <div className="main-content3">.</div> */}
                    {/* doctor sign  */}
                    {/* <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "50px" }}>
                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* <div className="br">.</div> */}
                    {/* <div className="main-content2">.</div> */}
                    {/* <div className="main-content3">.</div> */}
                    <div className="br">.</div>
                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            CLINICAL SIGNIFICANCE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {bcrSignificance?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "14px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "35px", }}
                                            rows={7}
                                            cols={142}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateSignificance(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>

                            );
                        })}
                    </div>

                    {/* <div className="br">.</div> */}
                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            CLINICAL USES
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "40px", fontSize: "14px" }}>
                        <p >
                            The quantitative BCR-ABL RNA assay is intended to monitor the level of minimal residual disease in TKI-treated Philadelphia chromosome positive leukemia’s (CML or ALL). High or rising BCR-ABL RNA levels have been shown to increase the risk of leukemic relapse and drug-resistance mutations during TKI therapy. The failure to achieve a “major
                            molecular response”, a 3- log drop in BCR-ABL RNA, defined as 0.1% on the BCR-ABL RNA PCR international scale (IS), is the consensus definition of a “sub-optimal”
                            treatment that requires an alternative treatment approach.
                        </p>
                    </div>

                    <br /><br />
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    {/* <div className="br">.</div>
                    <div className="br">.</div> */}

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{bcrReport[0]?.designation}&nbsp;{bcrReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{bcrReport[0]?.pk}
                    </div>
                    <div className="br">.</div>
                    {/* static data  */}
                    <div >
                        <img src={asset} alt="graph" style={{ width: "90%", marginLeft: "40px", height: "500px" }} />
                    </div>
                    <div className="br">.</div>
                    <table style={{ width: "90%", marginLeft: "40px", height: "350px" }}>
                        <tr style={{ border: "1px solid black ", background: "rgb(22 55 88)", color: "white" }}>
                            <th>ABBREVIATION</th>
                            <th>FULL FORM</th>
                            <th>INFERENCE</th>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) ", background: "rgb(221, 237, 236)" }}>
                            <td className="Table">CHR</td>
                            <td className="Table">Complete Hematological Response</td>
                            <td className="Table">Blood count returning to normal values</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) " }}>
                            <td className="Table">MCyR</td>
                            <td className="Table">Major Cytogenetic Response</td>
                            <td className="Table">Ph Chromosome 1-35% on FISH</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) ", background: "rgb(221, 237, 236" }}>
                            <td className="Table">CCyR</td>
                            <td className="Table">Complete Cytogenetic Response</td>
                            <td className="Table">Ph Chromosome 0% on FISH</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) " }}>
                            <td className="Table">MMR</td>
                            <td className="Table">Major Molecular Response</td>
                            <td className="Table">BCR-ABLIS &lt;0.1</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) ", background: "rgb(221, 237, 236" }}>
                            <td className="Table">MR4</td>
                            <td className="Table">Molecular Response</td>
                            <td className="Table">Molecular Response with 4 Log reduction</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) " }}>
                            <td className="Table">MR4.5</td>
                            <td className="Table">Molecular Response</td>
                            <td className="Table">Molecular Response with 4.5 Log reduction (Deep MR)</td>
                        </tr>
                        <tr style={{ border: "1px solid rgb(22 55 88) ", background: "rgb(221, 237, 236" }}>
                            <td className="Table">MRS</td>
                            <td className="Table">Molecular Response</td>
                            <td className="Table">Molecular Response with 5 Log reduction</td>
                        </tr>
                    </table>
                    {/* <div className="br">.</div>
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div className="main-content2">.</div> */}
                    {/* <div className="main-content3">.</div> */}
                    {/* <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{bcrReport[0]?.designation}&nbsp;{bcrReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{bcrReport[0]?.pk}
                    </div> */}
                    {/* <div className="br">.</div> */}
                    {/* <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            CLINICAL SIGNIFICANCE
                        </span>
                    </div> */}
                    {/* <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} /> */}
                    {/* <div>
                        {bcrSignificance?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "14px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "35px", }}
                                            rows={5}
                                            cols={142}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateSignificance(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>

                            );
                        })}
                    </div>

                    <br /><br /> */}
                    <br /><br />
                    {/* methology  */}
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            METHODOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {bcrMethology.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none" }}
                                            rows={4}
                                            cols={142}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMethology(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>


                    {/* upload image  */}
                    {/* <div style={{ display: "flex" }}>
                        <> */}
                            {/* <div>
                                {bcrgraph.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', height: 'auto' }}
                                                        />
                                                    </div>
                                                )
                                            }
                                           
                                            {index === 0 && filePreviews[index] && (
                                                <div>
                                                    {filePreviews[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", height: "auto" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div> */}
                            {/* <div>
                                {bcrgraph1.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                           
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image1' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', height: 'auto' }}
                                                        />
                                                    </div>
                                                )
                                            }
                                          
                                            {index === 0 && filePreviews1[index] && (
                                                <div>
                                                    {filePreviews1[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", height: "auto" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload1(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div> */}
                        {/* </>
                    </div> */}
                    {/* patient details page 1 */}
                    {/* <br /> */}
                    {/* comments  */}
                    {/* <div>
                        <h5 style={{ color: "rgb(28, 78, 128)", marginLeft: "50px", fontWeight: "bold" }}>
                            Comments-
                        </h5>
                    </div> */}
                    {/* <div className="contain" style={{ border: "none", width: "95%", background: "none", marginLeft: "40px", padding: 8, marginTop: "-10px" }}>

                        {bcrComment?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={133}
                                            rows={6}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateComments(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> */}
                    {/* doctor sign  */}
                    {/* <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    <div className="main-content2">.</div>
                    <div className="main-content3">.</div>

                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"

                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{bcrReport[0]?.designation}&nbsp;{bcrReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{bcrReport[0]?.pk}
                    </div>
                    <div className="br">.</div>
                    {/* limitations of assay  */}
                    {/* <div>
                        <h5 style={{ color: "rgb(28, 78, 128)", marginLeft: "50px", backgroundColor: "white", fontWeight: "bold" }}>
                            Limitation of assay -
                        </h5>
                    </div> */}
                    {/* <div
                        className="contain"
                        style={{ border: "none", width: "92%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}
                    >

                        {Limitations?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={133}
                                            rows={5}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateLimitations(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> */}

                    {/* <div className="br">.</div> */}

                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            TEST NOTES & LIMITATIONS
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ fontSize: "14px", marginLeft: "40px", width: "93%" }}>
                        <ol>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    The result of this test should be interpreted in correlation with clinical and hematological parameters.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Laboratory tests are merely a tool to assist in the diagnosing process and should be clinically correlated by the Referring Physician.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Analytical Sensitivity (Limit of Detection) of the Assay is 0.0032%.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Samples must be received at the laboratory under appropriate conditions within 48hrs of aspiration to ensure preservation of RNA integrity.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    PCR is a highly sensitive technique; common reasons for paradoxical results are contamination during specimen collection, selection of inappropriate specimen
                                    and inherent PCR inhibitors in the sample.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    It is recommended that RT-PCR test be performed at a frequency of every 3 months until major molecular response [MMR] is obtained following which the test
                                    can be done at a lesser frequency of once in every 6 months.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Sensitivity of the assay is 0.01% when copies of ABL detected is 100,000. Sensitivity is 0.001% when ABL copies detected is 10,00,000 copies/PCR.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Lower limit of transcript detection is a factor of cellular integrity of the clinical sample.
                                </p>
                            </li>
                  
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    This test gives percentage % of BCR-ABL fusion gene transcript detected with respect to the ABL1 transcript present as well as the International Scale Value to harmonize the
                                    result.
                                </p>
                            </li>

                        </ol>
                    </div>
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "20px" }}>TEST DISCLAIMER</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div className="contain" style={{ border: "none", width: "93%", backgroundColor: "white", marginLeft: "40px" }}>
                        <br />
                        <ul>
                            <li>
                                <p>Test results released pertain to the specimen submitted .</p>
                            </li>
                            <li>
                                <p>
                                    All test results are dependent on the quality of the sample
                                    received by the Laboratory .
                                </p>
                            </li>
                            <li>
                                <p>
                                    Laboratory investigations are only a tool to facilitate in
                                    arriving at a diagnosis and should be clinically correlated by
                                    the Referring Physician .
                                </p>
                            </li>
                            <li>
                                <p>
                                    Certain tests may require further testing at additional cost
                                    for derivation of exact value. Kindly submit request within 72
                                    hours post reporting.
                                </p>
                            </li>
                            <li>
                                <p>Test results may show inter laboratory variations.</p>
                            </li>
                            <li>
                                <p>
                                    If Sample collection date is not stated on test requisition
                                    form, the current date will be printed by default as the date
                                    of collection.
                                </p>
                            </li>
                            <li>
                                <p>Test results are not valid for medico legal purposes.</p>
                            </li>
                        </ul>
                    </div>

                    <div className="br">.</div>
                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            REFERENCE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ fontSize: "14px", marginLeft: "40px", width: "93%" }}>
                        <ol>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Foroni L, Wilson G et al. Br J. Haematol (2011) Apr 153(2): 179-190
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Baccarani M, Castagnetti F et al. Ann. Hematol (2015) Apr 94(Suppl) 2:S141-147
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Cross NC, White HE et al. Leukemia (2015) May 29(5): 999-1003
                                </p>
                            </li>
                        </ol>
                    </div>

                    {/* <div className="br">.</div> */}
                    {/* <div>
                        <h5 style={{ color: "rgb(28, 78, 128)", marginLeft: "40px", fontWeight: "bold" }}>
                            Test Details-
                        </h5>
                    </div> */}
                    {/* <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {textDetail?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={133}
                                            rows={6}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updatetextDetail(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> */}
                    {/* <div
                        className="container"
                        style={{ border: "none", backgroundColor: "white" }}
                    >
                        <p style={{ color: "rgb(28, 78, 128)", width: "95%", marginLeft: "0px" }}>
                            This test gives percentage of BCR-ABL fusion gene detected with
                            respect to the ABL transcript present as well as the International
                            Scale Value to harmonize the result
                        </p>
                    </div> */}

                    {/* <div className="br">.</div> */}
                    <div className="main-content3">.</div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "18px" }}>

                        {bcrdoctorList && bcrdoctorList?.length > 0 && bcrdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>
                    {/* patient details page 2 end */}

                    {/* footer section starting */}
                    <div className="page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>genee@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                    </div>
                     {
                                                                uuid && (
                                                                    <div className="hide-section-rating">
                                                                        <NpsRating bookingId={firstP} uuid={uuid} />
                                                                    </div>
                                                                )
                                                            }
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(NbsReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}